import * as React from "react";

function LogoComponent(props) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/logo-light.png`}
      alt="Logo"
      width={110}
      height={47}
      {...props}
    />
  );
}

export default LogoComponent;
